import { render, staticRenderFns } from "./uploadImgBack.vue?vue&type=template&id=4e8a6b75&"
import script from "./uploadImgBack.vue?vue&type=script&lang=js&"
export * from "./uploadImgBack.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgBack.vue?vue&type=style&index=0&id=4e8a6b75&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports